import App from '@/App.vue';
// global styles
import '@/assets/styles/main.scss';
// import '@/helpers/apm';
import { i18n, loadLocale } from '@/locales/i18n';
import pinia from '@/stores';
import { useAppStore } from '@/stores/app';
import { createHead } from '@vueuse/head';
import { createApp } from 'vue';
import { VueRecaptchaPlugin } from 'vue-recaptcha';

const app = createApp(App);
const head = createHead();

app.use(i18n);
app.use(pinia);
app.use(head);

const initializeApp = async () => {
  await loadLocale('fa');

  const { default: router } = await import('@/router');
  app.use(router);

  const { default: sentry } = await import('@/helpers/sentry');
  app.use(sentry, router);

  // We need to wait for the recaptcha info to be fetched then mount the app
  const appStore = useAppStore();
  await appStore.getRecaptchaInfo();

  app.use(VueRecaptchaPlugin, {
    v2SiteKey: appStore.recaptchaInfo.siteKey,
  });

  app.mount('#app');
};

const routeLoadingBar = document.createElement('div');
routeLoadingBar.id = 'route-loading-bar';
document.body.appendChild(routeLoadingBar);

initializeApp();
